/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useLocation } from 'js/lib/useRouter';

import { Grid } from '@coursera/cds-core';

import ConsumerSearchBarGridItem from 'bundles/composable-page-header-consumer/components/ConsumerSearchBarGridItem';
import ExploreMegaMenuGridItem from 'bundles/composable-page-header-consumer/components/ExploreMegaMenuGridItem';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import NavLinkGridItem from 'bundles/composable-page-header/components/grid-items/NavLinkGridItem';
import UnauthenticatedActionsGridItem from 'bundles/composable-page-header/components/grid-items/UnauthenticatedActionsGridItem';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import { logInButtonProps, signUpButtonProps } from 'bundles/composable-page-header/constants';
import isOnDegreePage from 'bundles/composable-page-header/utils/isOnDegreePage';
import { getShouldShowCourseraPlusEntrypointInNav } from 'bundles/coursera-plus-common/utils/subscriptionsForwardDiscoveryExperiment';

import _t from 'i18n!nls/composable-page-header-consumer';

const styles = {
  leftSide: css`
    width: auto;
  `,
  middleSide: css`
    flex-shrink: 1;
    flex-grow: 1;
    flex-basis: 0%;
    padding: 0 16px;
    width: 100%;
  `,
  rightSide: css`
    width: auto;
  `,
};

type Props = {
  hideAuthButtons?: boolean;
  showDiscoveryElements?: boolean;
};

const LoggedOutConsumerDesktopMainNav = ({ showDiscoveryElements = true, hideAuthButtons }: Props) => {
  const location = useLocation();
  const showCPlusLink = getShouldShowCourseraPlusEntrypointInNav();

  return (
    <MainNavigationWrapper>
      <Grid item container alignItems="center" spacing={8} css={styles.leftSide}>
        <Grid item>
          <HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo key="1" />]} className="c-logo" />
        </Grid>
        {showDiscoveryElements && (
          <Grid item>
            <ExploreMegaMenuGridItem />
          </Grid>
        )}
        <NavLinkGridItem
          label={_t('Degrees')}
          href="/degrees"
          name="degrees"
          trackingName="logged_out_online_degrees"
          isCurrent={isOnDegreePage(location.pathname)}
          isButton
        />
      </Grid>
      <Grid item container alignItems="center" css={styles.middleSide}>
        {showDiscoveryElements && <ConsumerSearchBarGridItem />}
      </Grid>
      <Grid item container alignItems="center" justifyContent="flex-end" wrap="nowrap" css={styles.rightSide}>
        {showCPlusLink && (
          <NavLinkGridItem
            label={_t('Coursera Plus')}
            href="/courseraplus"
            name="coursera_plus"
            trackingName="logged_out_coursera_plus"
          />
        )}

        {!hideAuthButtons && <UnauthenticatedActionsGridItem buttons={[logInButtonProps(), signUpButtonProps()]} />}
      </Grid>
    </MainNavigationWrapper>
  );
};

export default LoggedOutConsumerDesktopMainNav;
